import { defineDerivedMeasurement } from './DerivedMeasurement.js';
/**
 * System-derived Body Mass Index. Stored in kg/m² (LOINC 39156-5); never a patient input. The
 * derivation (closest-in-time weight↔height pairing) lives in the observation pipeline.
 */
export const BodyMassIndex = defineDerivedMeasurement({
    canonical: 'kg/m2',
    loinc: '39156-5',
});
//# sourceMappingURL=BodyMassIndex.js.map